var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-layout-container"},[_c('LockedHeader'),(_vm.showStartSession)?_c('StartSessionOverlay'):_vm._e(),_c(_vm.asyncComponent,{tag:"component",staticClass:"content-component",attrs:{"content":_vm.getActiveContent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }